import { Component } from '@angular/core';

@Component({
  selector: 'mprd-digitalis-skeleton',
  templateUrl: './digitalis-skeleton.component.html',
})
export class DigitalisSkeletonComponent {
  constructor() {}
}
